export default "__VITE_ASSET__DvM1AmaK__"